import ContentApiAdapter from 'rise-ui/adapters/apis/rise-api/content.js';

import { service } from '@ember/service';
import { underscore } from '@ember/string';

/**
 * Base adapter for ember-data requests to data-admin server for node content
 */
export default class NodeContentApiAdapter extends ContentApiAdapter {
  @service apiHostBuilder;
  host = this.apiHostBuilder.build(super.host, 8080);
  // namespace = 'rise/content-rise-drupal/web/jsonapi/node';
  namespace = 'jsonapi/node';
  pathForType(type) {
    return underscore(type);
  }
}
